import TransformShop from "../../transforms/TransformShop";
import {SET_PRODUCT_SUGGESTIONS} from "./ProductSuggestionsTypes";


export function productSuggestionsReducer(state = TransformShop.toProductSuggestions(), action) {
    switch (action.type) {
        case SET_PRODUCT_SUGGESTIONS:
            // console.log("list : ", TransformShop.toProductSuggestions(action.data))
            return TransformShop.toProductSuggestions(action.data);
        default:
            return state;
    }
}
